module.exports = __webpack_public_path__ + "img/home_ai_banner.46a64393.png";